const initDirectives = (app, store) => {
  //   app.directive('auth', {
  //     mounted(el, binding) {
  //       const { value } = binding;
  //       const userAuth = store.state.user.authBtns
  //       if (userAuth === '*') return;
  //       const hasPermission = userAuth.some(item => item.AuthCode === value);
  //       if (!hasPermission) {
  //         el.style.display = 'none';
  //       }
  //     }
  //   })
};
export default initDirectives;